import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack, Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import NativeSelect from "@mui/material/NativeSelect";
import InputBase from "@mui/material/InputBase";
import { getUserMaintanenceData } from "../../Redux/UserMaintanence";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { updateSupervisor } from "../../Redux/UserMaintanence";
import { addUser } from "../../Redux/UserMaintanence";
import { CloseIcon } from "@mui/icons-material";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          {/* <CloseIcon /> */}
          <img
            src={process.env.PUBLIC_URL + "/images/Home/close_img.png"}
            alt="icon"
            className="form_close_img"
          />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#7500C0"),
  backgroundColor: "#7500C0",
  "&:hover": {
    backgroundColor: "#7500C0",
    color: "#fff",
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

function EditSupervisor(props) {
  const dispatch = useDispatch();
  const [newUser, setNewUser] = useState("");
  const [newSuper, setNewSuper] = useState("");
  const [isUserNameNull, setIsUserNameNull] = useState(false);
  const [isSuperNameNull, setIsSuperNameNull] = useState(false);
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);

  const handleClose = () => {
    props.setOpenEdit(false);
    setNewUser("");
    setNewSuper("");
    setIsAddUserOpen(false);
    // dispatch(getUserMaintanenceData());
  };
  //  function to save the qa's
  const saveAddHandle = () => {
    if (newSuper == "") {
      setIsUserNameNull(true);
      setIsAddUserOpen(true);
      // dispatch(getUserMaintanenceData());
    }
    if (newSuper != "") {
      
      dispatch(updateSupervisor(newSuper, props.entId));
      props.setBoolChecked(true);
      setIsUserNameNull(false);
      setIsSuperNameNull(false);
      setNewUser("");
      setNewSuper("");
      props.setOpenEdit(false);
      setIsAddUserOpen(false);
    }
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.openEdit}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          className="popup"
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            textAlign: "center",
            paddingBottom: "0px !important",
          }}
          onClose={handleClose}
        >
          Edit Supervisor
        </BootstrapDialogTitle>
        <DialogContent sx={{ paddingTop: "15px", width: "600px" }}>
          <Stack
            sx={{ padding: "10px", marginTop: "10px", alignItems: "center" }}
            spacing={2}
          >
            <Stack spacing={1}>
              <Typography sx={{ fontSize: "14px" }}>
                Current Supervisor ID <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                // error={isUserNameNull && isAddUserOpen ? true : false}
                // required={isUserNameNull && isAddUserOpen ? false : true}
                className="coursecode-textfield"
                size="small"
                fullWidth
                multiline
                id={
                  isUserNameNull && isAddUserOpen
                    ? "outlined-error"
                    : "outlined-required"
                }
                variant="outlined"
                helperText={
                  isUserNameNull && isAddUserOpen
                    ? "Please enter the user name"
                    : null
                }
                value={props.supervisorRowId}
                disabled
                sx={{
                  width: "100%",
                  fontSize: "14px !important",
                  alignItems: "center",
                }}
                maxLength="500"
                autoComplete="off"
              />
              <Typography sx={{ fontSize: "14px" }}>
                Enter New Supervisor ID <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                error={isSuperNameNull && isAddUserOpen ? true : false}
                required={isSuperNameNull && isAddUserOpen ? false : true}
                className="coursecode-textfield"
                size="small"
                fullWidth
                multiline
                id={
                  isSuperNameNull && isAddUserOpen
                    ? "outlined-error"
                    : "outlined-required"
                }
                variant="outlined"
                helperText={
                  isSuperNameNull && isAddUserOpen
                    ? "Please enter the supervisor name"
                    : null
                }
                onChange={(e) => {
                  setNewSuper(e.target.value);
                  if (newSuper !== "") {
                    setIsSuperNameNull(false);
                  }
                }}
                sx={{
                  width: "100%",
                  fontSize: "14px !important",
                  alignItems: "center",
                }}
                maxLength="500"
                autoComplete="off"
              />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <ColorButton
            variant="contained"
            className="save-button"
            size="small"
            sx={{ background: "#7500C0", color: "white" }}
            // autoFocus
            onClick={saveAddHandle}
          >
            Submit
          </ColorButton>
          <ColorButton
            variant="contained"
            className="cancel-button"
            size="small"
            sx={{
              background: "white",
              color: "#7500C0",
              border: "solid 1px #7500C0",
            }}
            // autoFocus
            onClick={handleClose}
          >
            Cancel
          </ColorButton>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}

export default EditSupervisor;
